// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5431b0dd","455":"578a8ab3","977":"9097030c"}[chunkId] + ".chunk.js";
};